import React from 'react';

const ACTION_TYPES = [
    'lead.assign_round_robin',
    'lead.set_status',
    'lead.add_tag',
    'activity.create',
    'notify.create',
    'message.send',
];

const ActivityTypes = ['call', 'task', 'meeting', 'site_visit_followup', 'whatsapp', 'note'];

const ActionRow = ({ action, onChange, onRemove, templates = [] }) => {
    const handleTypeChange = (type) => {
        let next = { type };
        if (type === 'lead.set_status') {
            next.status = 'new';
        }
        if (type === 'lead.add_tag') {
            next.tag = '';
        }
        if (type === 'activity.create') {
            next.activityType = 'call';
            next.title = '';
        }
        if (type === 'notify.create') {
            next.title = '';
            next.body = '';
            next.severity = 'info';
        }
        if (type === 'message.send') {
            next.channel = 'whatsapp';
            next.templateId = '';
            next.delayMins = '';
        }
        onChange(next);
    };

    return (
        <div style={{ border: '1px solid var(--crm-gray-200)', padding: '12px', borderRadius: '12px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 40px', gap: '12px', alignItems: 'center' }}>
                <select
                    className="crm-select"
                    value={action.type || ''}
                    onChange={(e) => handleTypeChange(e.target.value)}
                >
                    {ACTION_TYPES.map((type) => (
                        <option key={type} value={type}>{type}</option>
                    ))}
                </select>
                <button className="crm-btn crm-btn-secondary crm-btn-sm" type="button" onClick={onRemove}>
                    ✕
                </button>
            </div>

            {action.type === 'lead.assign_round_robin' && (
                <div style={{ marginTop: '12px', display: 'grid', gap: '12px' }}>
                    <div>
                        <label className="crm-label">Team/Group (optional)</label>
                        <input
                            className="crm-input"
                            value={action.group || ''}
                            onChange={(e) => onChange({ ...action, group: e.target.value })}
                        />
                    </div>
                    <label className="crm-inline-check">
                        <input
                            type="checkbox"
                            checked={Boolean(action.fallbackToAdmin)}
                            onChange={(e) => onChange({ ...action, fallbackToAdmin: e.target.checked })}
                        />
                        <span>Fallback to admin</span>
                    </label>
                </div>
            )}

            {action.type === 'lead.set_status' && (
                <div style={{ marginTop: '12px' }}>
                    <label className="crm-label">Status</label>
                    <select
                        className="crm-select"
                        value={action.status || 'new'}
                        onChange={(e) => onChange({ ...action, status: e.target.value })}
                    >
                        {['new', 'contacted', 'qualified', 'unqualified', 'converted'].map((status) => (
                            <option key={status} value={status}>{status}</option>
                        ))}
                    </select>
                </div>
            )}

            {action.type === 'lead.add_tag' && (
                <div style={{ marginTop: '12px' }}>
                    <label className="crm-label">Tag</label>
                    <input
                        className="crm-input"
                        value={action.tag || ''}
                        onChange={(e) => onChange({ ...action, tag: e.target.value })}
                    />
                </div>
            )}

            {action.type === 'activity.create' && (
                <div style={{ marginTop: '12px', display: 'grid', gap: '12px' }}>
                    <div>
                        <label className="crm-label">Activity Type</label>
                        <select
                            className="crm-select"
                            value={action.activityType || 'call'}
                            onChange={(e) => onChange({ ...action, activityType: e.target.value })}
                        >
                            {ActivityTypes.map((type) => (
                                <option key={type} value={type}>{type}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="crm-label">Title</label>
                        <input
                            className="crm-input"
                            value={action.title || ''}
                            onChange={(e) => onChange({ ...action, title: e.target.value })}
                        />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div>
                            <label className="crm-label">Due in minutes</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={action.dueInMins || ''}
                                onChange={(e) => onChange({ ...action, dueInMins: e.target.value })}
                            />
                        </div>
                        <div>
                            <label className="crm-label">Due at (epoch ms)</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={action.dueAt || ''}
                                onChange={(e) => onChange({ ...action, dueAt: e.target.value })}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="crm-label">Notes</label>
                        <textarea
                            className="crm-textarea"
                            rows={2}
                            value={action.notes || ''}
                            onChange={(e) => onChange({ ...action, notes: e.target.value })}
                        />
                    </div>
                </div>
            )}

            {action.type === 'notify.create' && (
                <div style={{ marginTop: '12px', display: 'grid', gap: '12px' }}>
                    <div>
                        <label className="crm-label">Message</label>
                        <input
                            className="crm-input"
                            value={action.title || ''}
                            onChange={(e) => onChange({ ...action, title: e.target.value })}
                        />
                    </div>
                    <div>
                        <label className="crm-label">Severity</label>
                        <select
                            className="crm-select"
                            value={action.severity || 'info'}
                            onChange={(e) => onChange({ ...action, severity: e.target.value })}
                        >
                            {['info', 'warning', 'critical'].map((sev) => (
                                <option key={sev} value={sev}>{sev}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="crm-label">Body</label>
                        <textarea
                            className="crm-textarea"
                            rows={2}
                            value={action.body || ''}
                            onChange={(e) => onChange({ ...action, body: e.target.value })}
                        />
                    </div>
                </div>
            )}

            {action.type === 'message.send' && (
                <div style={{ marginTop: '12px', display: 'grid', gap: '12px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div>
                            <label className="crm-label">Channel</label>
                            <select
                                className="crm-select"
                                value={action.channel || 'whatsapp'}
                                onChange={(e) => onChange({ ...action, channel: e.target.value })}
                            >
                                <optgroup label="Messaging">
                                    {['whatsapp', 'sms', 'email', 'telegram'].map((channel) => (
                                        <option key={channel} value={channel}>{channel}</option>
                                    ))}
                                </optgroup>
                                <optgroup label="Meta Social">
                                    {['instagram_dm', 'facebook_messenger'].map((channel) => (
                                        <option key={channel} value={channel}>{channel}</option>
                                    ))}
                                </optgroup>
                                <optgroup label="Social Replies">
                                    {['instagram_comment_reply', 'facebook_comment_reply'].map((channel) => (
                                        <option key={channel} value={channel}>{channel}</option>
                                    ))}
                                </optgroup>
                                <optgroup label="Other">
                                    {['linkedin_message', 'webhook'].map((channel) => (
                                        <option key={channel} value={channel}>{channel}</option>
                                    ))}
                                </optgroup>
                            </select>
                        </div>
                        <div>
                            <label className="crm-label">Delay (mins)</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={action.delayMins || ''}
                                onChange={(e) => onChange({ ...action, delayMins: e.target.value })}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="crm-label">Template</label>
                        <select
                            className="crm-select"
                            value={action.templateId || ''}
                            onChange={(e) => onChange({ ...action, templateId: e.target.value })}
                        >
                            <option value="">Select template</option>
                            {templates
                                .filter((template) => !action.channel || template.channel === action.channel)
                                .map((template) => (
                                    <option key={template.id} value={template.id}>
                                        {template.name} ({template.channel})
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionRow;
